import HTTP from '@/utils/http';

const Types = {
  getTypes: () => HTTP.get('type').then(response => response.data),
};

export default Types;
